<mat-dialog-content class="modal">
  <h3>Nicht in unserem Produktfokus enthalten</h3>
  <p>
    Derzeit bieten wir für Wasserkraftanlagen keine Angebote für die Direktvermarktung an. Wir
    werden den Fokus zukünftig auf Solar und Wind ausrichten.
  </p>

  <p>Wir bedauern diesen Schritt und bedanken uns für Ihr Verständnis.</p>

  <p>Vielen Dank für Ihr Verständnis!</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="modal-button" (click)="closeDialog()">Schließen</button>
</mat-dialog-actions>
